export const onClientEntry = () => {
  require('gsap')
  require('scrollmagic')
  require('gsap/src/uncompressed/plugins/ScrollToPlugin')
}

export {
  default as wrapRootElement
} from './src/state/reduxWrapper'
